import type { ComponentType } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

import { PaneBodyFallback } from './PaneBodyFallback';

export type PaneErrorBoundaryProps = React.PropsWithChildren<{
  fallback?: ComponentType<FallbackProps>;
  onError?: (error: Error, info: { componentStack: string | null }) => void;
}>;

export const PaneErrorBoundary = ({
  children,
  fallback,
  onError,
}: PaneErrorBoundaryProps) => {
  return (
    <ErrorBoundary
      FallbackComponent={fallback ?? PaneBodyFallback}
      onError={onError}
    >
      {children}
    </ErrorBoundary>
  );
};
